import React from 'react';
import SkeletonBox from './SkeletonBox';
import {getRandomNumber} from 'utility/numbers';

const SkeletonTitle = ({style={}}) => {
  const randomWidth = getRandomNumber(35, 70);
  return <SkeletonBox width={`${randomWidth}%`} style={style}/>
}

export default SkeletonTitle;